/** 비디오 리사이즈 컨트롤러 — 좌/우 핸들=previewWidth, 하단 핸들=previewHeight. */
import { startDragResize } from "../../shared/drag-resize.js";

const MIN_W = 100, MAX_W = 1200, MIN_H = 120, MAX_H = 600;

export function attachVideoControls(editorEl, ctx) {
  const onChange = (ctx && ctx.onChange) || (() => {});
  const isEditable = () => (ctx && typeof ctx.isEditable === "function" ? ctx.isEditable() : true);
  function onMousedown(e) {
    if (!isEditable()) return; // 읽기전용에선 리사이즈 비활성
    const h = e.target.closest && e.target.closest(".lumir-video-handle");
    if (!h) return;
    e.preventDefault();
    const block = h.closest(".block");
    const inner = h.closest(".lumir-video-inner");
    if (!block || !inner) return;
    if (!block.__props) block.__props = {};
    if (h.classList.contains("bottom")) {
      const video = inner.querySelector("video");
      const measuredH = video && video.getBoundingClientRect ? Math.round(video.getBoundingClientRect().height) : 0;
      const startH = block.__props.previewHeight || measuredH || 360;
      startDragResize(e, {
        axis: "y", startVal: startH, min: MIN_H, max: MAX_H, sign: 1,
        onMove: (hh) => { block.__props.previewHeight = hh; if (video) video.style.height = hh + "px"; },
        onEnd: onChange,
      });
      return;
    }
    const measured = inner.getBoundingClientRect ? Math.round(inner.getBoundingClientRect().width) : 0;
    const startW = block.__props.previewWidth || measured || 320;
    startDragResize(e, {
      axis: "x", startVal: startW, min: MIN_W, max: MAX_W, sign: h.classList.contains("left") ? -1 : 1,
      onMove: (w) => { block.__props.previewWidth = w; inner.style.width = w + "px"; },
      onEnd: onChange,
    });
  }
  editorEl.addEventListener("mousedown", onMousedown);
  return { destroy: () => editorEl.removeEventListener("mousedown", onMousedown) };
}
